import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import {
  ThemeProvider,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import theme from "./data/theme";
import { AuthProvider } from "./context/AuthContext";
import HandleRoutes from "./routes/HandleRoutes";
import { SnackbarProvider } from "notistack";

const useStyles = makeStyles(() =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        height: "100%",

        width: "100%",
      },
      "#root": {
        height: "100%",
        minWidth: 960,
        width: "100%",
      },
      "input[type=number]::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
      },
      "input[type=number]::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
      },
    },
  })
);

function App() {
  useStyles();
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={1}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        autoHideDuration={2000}
      >
        <AuthProvider>
          <Router>
            <HandleRoutes />
          </Router>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
